import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import RoofReplacementPage from '../pages/services/roof-replacement/page';
import RoofRepairPage from '../pages/services/roof-repair/page';
import CommercialRoofingPage from '../pages/services/commercial/page';
import StormDamagePage from '../pages/services/storm-damage/page';
import AboutPage from '../pages/about/page';
import SaltLakeCityPage from '../pages/locations/salt-lake-city/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services/roof-replacement',
    element: <RoofReplacementPage />,
  },
  {
    path: '/services/roof-repair',
    element: <RoofRepairPage />,
  },
  {
    path: '/services/commercial',
    element: <CommercialRoofingPage />,
  },
  {
    path: '/services/storm-damage',
    element: <StormDamagePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/locations/salt-lake-city',
    element: <SaltLakeCityPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
